import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { DecodeTokenAuth } from "../../lib/token";
import { updatePassword } from "../../redux/slices/resets";

const schema = yup.object().shape({
  password: yup
    .string()
    .min(3, "Password must be at least 3 characters")
    .required("New password is required"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm password is required"),
});

function NewPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const token = url.search.substring(1);
    const getid = DecodeTokenAuth(token);
    setToken(token);
  }, []);

  const loading = useSelector((state) => state?.resets.loading);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const payload = {
      password: data?.password,
      token: token,
    };
    try {
      await dispatch(updatePassword(payload));
      navigate("/login");
    } catch (err) {
      console.error("Error updating password:", err);
    }
  };

  return (
    <section
      className="account-section overflow-hidden bg_img"
      style={{
        background: `url(${process.env.PUBLIC_URL}/images/account/login-signup.jpg)`,
      }}
    >
      <div className="container">
        <div className="account__main__wrapper float-start">
          <div className="account__form__wrapper">
            <div className="content text-center text-white">
              <h3 className="title text--base mb-4">Create a New Password</h3>
              <p className="mb-4">
                Your new password must be different from previous passwords.
              </p>
            </div>

            <form
              className="account__form form row g-4"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="col-12">
                <div
                  className="form-group position-relative"
                  style={{ minHeight: "68px" }}
                >
                  <div className="input-pre-icon">
                    <i className="las la-lock"></i>
                  </div>
                  <input
                    {...register("password")}
                    type={showPassword ? "text" : "password"}
                    className={`form--control form-control style--two ${
                      errors.password ? "is-invalid" : ""
                    }`}
                    placeholder="New Password"
                    style={{ paddingRight: "40px" }}
                  />
                  <IconButton
                    className="position-absolute"
                    onClick={() => setShowPassword((prev) => !prev)}
                    sx={{
                      color: "white",
                      right: "8px",
                      top: "8px",
                      padding: "5px",
                    }}
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                  {errors.password && (
                    <div
                      className="invalid-feedback d-block"
                      style={{
                        position: "absolute",
                        bottom: "-8px",
                      }}
                    >
                      {errors.password.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div
                  className="form-group position-relative"
                  style={{ minHeight: "68px" }}
                >
                  <div className="input-pre-icon">
                    <i className="las la-lock"></i>
                  </div>
                  <input
                    {...register("confirmPassword")}
                    type={showConfirmPassword ? "text" : "password"}
                    className={`form--control form-control style--two ${
                      errors.confirmPassword ? "is-invalid" : ""
                    }`}
                    placeholder="Confirm New Password"
                    style={{ paddingRight: "40px" }}
                  />
                  <IconButton
                    className="position-absolute"
                    onClick={() => setShowConfirmPassword((prev) => !prev)}
                    sx={{
                      color: "white",
                      right: "8px",
                      top: "8px",
                      padding: "5px",
                    }}
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                  {errors.confirmPassword && (
                    <div
                      className="invalid-feedback d-block"
                      style={{
                        position: "absolute",
                        bottom: "-8px",
                      }}
                    >
                      {errors.confirmPassword.message}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-12">
                <div className="form-group">
                  <button
                    className="cmn--btn active w-100 btn--round"
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : (
                      "Update Password"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewPassword;
